import { Checkbox, DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOfficeAdditionalTaxesReport extends Layout {
    checkboxIncludeSettlements: Checkbox;
    checkboxReverseVoids: Checkbox;
    excludabletextboxPayAdjCodes: ExcludableTextbox;
    excludabletextboxPayees: ExcludableTextbox;
    excludabletextboxState: ExcludableTextbox;
    sourceAdditionalTaxes: DataSource;
    sourceAllPayees: DataSource;
    sourceOffPayee: DataSource;
    switchReportType: Switch;
    textboxDateRange: Textbox;
    textboxReportBy: Textbox;
    textboxSecondaryGroupBy: Textbox;
    textboxTaxType: Textbox;
}
